/**
 * Customer health thresholds -- shared by TopCustomersPage and
 * CustomerDetailView. Zero component imports so neither page creates a
 * circular import by pulling from the other.
 *
 * Critical: open case priority is Critical
 * Attention: open case idle past priority-based threshold
 * Else Healthy
 */

/** Idle days (last modified) before an open case counts as Attention, by priority. */
export const ATTENTION_IDLE_BY_PRIORITY = {
  Critical: 2,
  High: 4,
  Medium: 10,
  Low: 20
};

export const ATTENTION_IDLE_DAYS_DEFAULT = ATTENTION_IDLE_BY_PRIORITY.Medium;

export const attentionIdleDaysForPriority = (priority) => {
  const key = String(priority || '').trim();
  if (ATTENTION_IDLE_BY_PRIORITY[key] != null) return ATTENTION_IDLE_BY_PRIORITY[key];
  if (/critical/i.test(key)) return ATTENTION_IDLE_BY_PRIORITY.Critical;
  if (/\bhigh\b/i.test(key)) return ATTENTION_IDLE_BY_PRIORITY.High;
  if (/medium/i.test(key)) return ATTENTION_IDLE_BY_PRIORITY.Medium;
  if (/low/i.test(key)) return ATTENTION_IDLE_BY_PRIORITY.Low;
  return ATTENTION_IDLE_DAYS_DEFAULT;
};

export const isAttentionIdle = (idleDays, priority) => {
  if (idleDays == null || Number.isNaN(Number(idleDays))) return false;
  return Number(idleDays) > attentionIdleDaysForPriority(priority);
};

export const HEALTH_COLORS = {
  healthy: { color: '#2e7d32', bg: '#e8f5e9' },
  attention: { color: '#c85a00', bg: '#fbe9dd' },
  critical: { color: '#c62828', bg: '#fdecea' }
};
